// GENERATED by scripts/generate-routes.mjs — edit contracts/routes.yaml instead.

import { getCurrentLocale } from './locale-context'

export type Locale = 'en' | 'fr'
export const LOCALES = ['en', 'fr'] as const satisfies readonly Locale[]
export const DEFAULT_LOCALE: Locale = 'en'

/** Type-safe path builders — returns URL in the current locale. */
export const paths = {
  home: () => '/',
  login: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/connexion'
      default: return '/login'
    }
  },
  verifyEmail: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/verifier-email'
      default: return '/verify-email'
    }
  },
  invitation: () => '/invitation',
  biketeamMigration: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/migration-biketeam'
      default: return '/biketeam-migration'
    }
  },
  forgotPassword: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/mot-de-passe-oublie'
      default: return '/forgot-password'
    }
  },
  resetPassword: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/nouveau-mot-de-passe'
      default: return '/reset-password'
    }
  },
  deviceVerifyGarmin: () => '/garmin',
  deviceVerifyKaroo: () => '/karoo',
  deviceHammerhead: () => '/karoo/hammerhead',
  apps: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/applications'
      default: return '/apps'
    }
  },
  features: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/fonctionnalites'
      default: return '/features'
    }
  },
  privacy: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/confidentialite'
      default: return '/privacy'
    }
  },
  terms: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/cgu'
      default: return '/terms'
    }
  },
  support: () => '/support',
  profile: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/profil'
      default: return '/profile'
    }
  },
  notifications: () => '/notifications',
  profilePreferences: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/profil/preferences'
      default: return '/profile/preferences'
    }
  },
  profileNotifications: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/profil/notifications'
      default: return '/profile/notifications'
    }
  },
  profileDevices: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/profil/appareils'
      default: return '/profile/devices'
    }
  },
  profileSecurity: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/profil/securite'
      default: return '/profile/security'
    }
  },
  profilePrivacy: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/profil/vie-privee'
      default: return '/profile/privacy'
    }
  },
  blockedUsers: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/profil/vie-privee/bloques'
      default: return '/profile/privacy/blocked'
    }
  },
  profileAccount: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/profil/compte'
      default: return '/profile/account'
    }
  },
  profileHelp: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/profil/aide'
      default: return '/profile/help'
    }
  },
  calendar: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/calendrier'
      default: return '/calendar'
    }
  },
  allRoutes: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/parcours'
      default: return '/routes'
    }
  },
  allRoutesMap: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/parcours/carte'
      default: return '/routes/map'
    }
  },
  gpxTools: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/outils-gpx'
      default: return '/gpx-tools'
    }
  },
  gpxToolsList: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/outils-gpx/mes-fichiers'
      default: return '/gpx-tools/my-files'
    }
  },
  gpxToolsNew: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/outils-gpx/nouveau'
      default: return '/gpx-tools/new'
    }
  },
  gpxToolsBlankMap: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/outils-gpx/carte'
      default: return '/gpx-tools/map'
    }
  },
  gpxToolsView: (previewId: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/outils-gpx/${previewId}`
      default: return `/gpx-tools/${previewId}`
    }
  },
  gpxToolsMap: (previewId: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/outils-gpx/${previewId}/carte`
      default: return `/gpx-tools/${previewId}/map`
    }
  },
  gpxToolsEdit: (previewId: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/outils-gpx/${previewId}/modifier`
      default: return `/gpx-tools/${previewId}/edit`
    }
  },
  teams: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/equipes'
      default: return '/teams'
    }
  },
  teamsNew: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/equipes/nouvelle'
      default: return '/teams/new'
    }
  },
  team: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}`
      default: return `/teams/${teamSlug}`
    }
  },
  teamAbout: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/a-propos`
      default: return `/teams/${teamSlug}/about`
    }
  },
  teamCalendar: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/calendrier`
      default: return `/teams/${teamSlug}/calendar`
    }
  },
  teamAgenda: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/agenda`
      default: return `/teams/${teamSlug}/agenda`
    }
  },
  teamPosts: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/articles`
      default: return `/teams/${teamSlug}/posts`
    }
  },
  teamRides: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/sorties`
      default: return `/teams/${teamSlug}/rides`
    }
  },
  teamTrips: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/voyages`
      default: return `/teams/${teamSlug}/trips`
    }
  },
  teamMembers: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/membres`
      default: return `/teams/${teamSlug}/members`
    }
  },
  teamPage: (teamSlug: string, pageSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/pages/${pageSlug}`
      default: return `/teams/${teamSlug}/pages/${pageSlug}`
    }
  },
  teamAdmin: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/admin`
      default: return `/teams/${teamSlug}/admin`
    }
  },
  teamAdminPlaces: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/admin/lieux`
      default: return `/teams/${teamSlug}/admin/places`
    }
  },
  teamAdminTags: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/admin/tags`
      default: return `/teams/${teamSlug}/admin/tags`
    }
  },
  teamAdminPages: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/admin/pages`
      default: return `/teams/${teamSlug}/admin/pages`
    }
  },
  teamAdminPageNew: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/admin/pages/nouvelle`
      default: return `/teams/${teamSlug}/admin/pages/new`
    }
  },
  teamAdminPageEdit: (teamSlug: string, pageSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/admin/pages/${pageSlug}/modifier`
      default: return `/teams/${teamSlug}/admin/pages/${pageSlug}/edit`
    }
  },
  teamAdminMembers: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/admin/membres`
      default: return `/teams/${teamSlug}/admin/members`
    }
  },
  teamAdminReports: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/admin/signalements`
      default: return `/teams/${teamSlug}/admin/reports`
    }
  },
  teamSettings: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/admin/parametres`
      default: return `/teams/${teamSlug}/admin/settings`
    }
  },
  rideNew: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/sorties/nouvelle`
      default: return `/teams/${teamSlug}/rides/new`
    }
  },
  ride: (teamSlug: string, rideSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/sorties/${rideSlug}`
      default: return `/teams/${teamSlug}/rides/${rideSlug}`
    }
  },
  rideGroup: (teamSlug: string, rideSlug: string, groupId: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/sorties/${rideSlug}/groupes/${groupId}`
      default: return `/teams/${teamSlug}/rides/${rideSlug}/groups/${groupId}`
    }
  },
  rideGroupMap: (teamSlug: string, rideSlug: string, groupId: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/sorties/${rideSlug}/groupes/${groupId}/carte`
      default: return `/teams/${teamSlug}/rides/${rideSlug}/groups/${groupId}/map`
    }
  },
  rideMap: (teamSlug: string, rideSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/sorties/${rideSlug}/carte`
      default: return `/teams/${teamSlug}/rides/${rideSlug}/map`
    }
  },
  rideEdit: (teamSlug: string, rideSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/sorties/${rideSlug}/modifier`
      default: return `/teams/${teamSlug}/rides/${rideSlug}/edit`
    }
  },
  rideTemplates: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/admin/modeles-sortie`
      default: return `/teams/${teamSlug}/admin/ride-templates`
    }
  },
  rideTemplateNew: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/admin/modeles-sortie/nouveau`
      default: return `/teams/${teamSlug}/admin/ride-templates/new`
    }
  },
  rideTemplateEdit: (teamSlug: string, templateSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/admin/modeles-sortie/${templateSlug}/modifier`
      default: return `/teams/${teamSlug}/admin/ride-templates/${templateSlug}/edit`
    }
  },
  tripNew: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/voyages/nouveau`
      default: return `/teams/${teamSlug}/trips/new`
    }
  },
  trip: (teamSlug: string, tripSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/voyages/${tripSlug}`
      default: return `/teams/${teamSlug}/trips/${tripSlug}`
    }
  },
  tripEdit: (teamSlug: string, tripSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/voyages/${tripSlug}/modifier`
      default: return `/teams/${teamSlug}/trips/${tripSlug}/edit`
    }
  },
  stage: (teamSlug: string, tripSlug: string, stageSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/voyages/${tripSlug}/etapes/${stageSlug}`
      default: return `/teams/${teamSlug}/trips/${tripSlug}/stages/${stageSlug}`
    }
  },
  stageMap: (teamSlug: string, tripSlug: string, stageSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/voyages/${tripSlug}/etapes/${stageSlug}/carte`
      default: return `/teams/${teamSlug}/trips/${tripSlug}/stages/${stageSlug}/map`
    }
  },
  postNew: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/articles/nouveau`
      default: return `/teams/${teamSlug}/posts/new`
    }
  },
  post: (teamSlug: string, postSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/articles/${postSlug}`
      default: return `/teams/${teamSlug}/posts/${postSlug}`
    }
  },
  postEdit: (teamSlug: string, postSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/articles/${postSlug}/modifier`
      default: return `/teams/${teamSlug}/posts/${postSlug}/edit`
    }
  },
  routes: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/parcours`
      default: return `/teams/${teamSlug}/routes`
    }
  },
  routesMap: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/parcours/carte`
      default: return `/teams/${teamSlug}/routes/map`
    }
  },
  routeNew: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/parcours/nouveau`
      default: return `/teams/${teamSlug}/routes/new`
    }
  },
  route: (teamSlug: string, routeSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/parcours/${routeSlug}`
      default: return `/teams/${teamSlug}/routes/${routeSlug}`
    }
  },
  routeMap: (teamSlug: string, routeSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/parcours/${routeSlug}/carte`
      default: return `/teams/${teamSlug}/routes/${routeSlug}/map`
    }
  },
  routeEdit: (teamSlug: string, routeSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/parcours/${routeSlug}/modifier`
      default: return `/teams/${teamSlug}/routes/${routeSlug}/edit`
    }
  },
  ads: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/annonces`
      default: return `/teams/${teamSlug}/classifieds`
    }
  },
  adNew: (teamSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/annonces/nouvelle`
      default: return `/teams/${teamSlug}/classifieds/new`
    }
  },
  ad: (teamSlug: string, adSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/annonces/${adSlug}`
      default: return `/teams/${teamSlug}/classifieds/${adSlug}`
    }
  },
  adEdit: (teamSlug: string, adSlug: string) => {
    switch (getCurrentLocale()) {
      case 'fr': return `/equipes/${teamSlug}/annonces/${adSlug}/modifier`
      default: return `/teams/${teamSlug}/classifieds/${adSlug}/edit`
    }
  },
  admin: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/plateforme'
      default: return '/platform'
    }
  },
  adminDomains: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/plateforme/domaines'
      default: return '/platform/domains'
    }
  },
  adminTeams: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/plateforme/equipes'
      default: return '/platform/teams'
    }
  },
  adminUsers: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/plateforme/utilisateurs'
      default: return '/platform/users'
    }
  },
  adminReports: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/plateforme/signalements'
      default: return '/platform/reports'
    }
  },
  adminMaintenance: () => {
    switch (getCurrentLocale()) {
      case 'fr': return '/plateforme/maintenance'
      default: return '/platform/maintenance'
    }
  },
} as const

/** Per-locale URL variants — returns all locale pattern strings. */
export const pathVariants = {
  home: (): Record<Locale, string> => ({ en: '/', fr: '/' }),
  login: (): Record<Locale, string> => ({ en: '/login', fr: '/connexion' }),
  verifyEmail: (): Record<Locale, string> => ({ en: '/verify-email', fr: '/verifier-email' }),
  invitation: (): Record<Locale, string> => ({ en: '/invitation', fr: '/invitation' }),
  biketeamMigration: (): Record<Locale, string> => ({ en: '/biketeam-migration', fr: '/migration-biketeam' }),
  forgotPassword: (): Record<Locale, string> => ({ en: '/forgot-password', fr: '/mot-de-passe-oublie' }),
  resetPassword: (): Record<Locale, string> => ({ en: '/reset-password', fr: '/nouveau-mot-de-passe' }),
  deviceVerifyGarmin: (): Record<Locale, string> => ({ en: '/garmin', fr: '/garmin' }),
  deviceVerifyKaroo: (): Record<Locale, string> => ({ en: '/karoo', fr: '/karoo' }),
  deviceHammerhead: (): Record<Locale, string> => ({ en: '/karoo/hammerhead', fr: '/karoo/hammerhead' }),
  apps: (): Record<Locale, string> => ({ en: '/apps', fr: '/applications' }),
  features: (): Record<Locale, string> => ({ en: '/features', fr: '/fonctionnalites' }),
  privacy: (): Record<Locale, string> => ({ en: '/privacy', fr: '/confidentialite' }),
  terms: (): Record<Locale, string> => ({ en: '/terms', fr: '/cgu' }),
  support: (): Record<Locale, string> => ({ en: '/support', fr: '/support' }),
  profile: (): Record<Locale, string> => ({ en: '/profile', fr: '/profil' }),
  notifications: (): Record<Locale, string> => ({ en: '/notifications', fr: '/notifications' }),
  profilePreferences: (): Record<Locale, string> => ({ en: '/profile/preferences', fr: '/profil/preferences' }),
  profileNotifications: (): Record<Locale, string> => ({ en: '/profile/notifications', fr: '/profil/notifications' }),
  profileDevices: (): Record<Locale, string> => ({ en: '/profile/devices', fr: '/profil/appareils' }),
  profileSecurity: (): Record<Locale, string> => ({ en: '/profile/security', fr: '/profil/securite' }),
  profilePrivacy: (): Record<Locale, string> => ({ en: '/profile/privacy', fr: '/profil/vie-privee' }),
  blockedUsers: (): Record<Locale, string> => ({ en: '/profile/privacy/blocked', fr: '/profil/vie-privee/bloques' }),
  profileAccount: (): Record<Locale, string> => ({ en: '/profile/account', fr: '/profil/compte' }),
  profileHelp: (): Record<Locale, string> => ({ en: '/profile/help', fr: '/profil/aide' }),
  calendar: (): Record<Locale, string> => ({ en: '/calendar', fr: '/calendrier' }),
  allRoutes: (): Record<Locale, string> => ({ en: '/routes', fr: '/parcours' }),
  allRoutesMap: (): Record<Locale, string> => ({ en: '/routes/map', fr: '/parcours/carte' }),
  gpxTools: (): Record<Locale, string> => ({ en: '/gpx-tools', fr: '/outils-gpx' }),
  gpxToolsList: (): Record<Locale, string> => ({ en: '/gpx-tools/my-files', fr: '/outils-gpx/mes-fichiers' }),
  gpxToolsNew: (): Record<Locale, string> => ({ en: '/gpx-tools/new', fr: '/outils-gpx/nouveau' }),
  gpxToolsBlankMap: (): Record<Locale, string> => ({ en: '/gpx-tools/map', fr: '/outils-gpx/carte' }),
  gpxToolsView: (previewId: string): Record<Locale, string> => ({ en: `/gpx-tools/${previewId}`, fr: `/outils-gpx/${previewId}` }),
  gpxToolsMap: (previewId: string): Record<Locale, string> => ({ en: `/gpx-tools/${previewId}/map`, fr: `/outils-gpx/${previewId}/carte` }),
  gpxToolsEdit: (previewId: string): Record<Locale, string> => ({ en: `/gpx-tools/${previewId}/edit`, fr: `/outils-gpx/${previewId}/modifier` }),
  teams: (): Record<Locale, string> => ({ en: '/teams', fr: '/equipes' }),
  teamsNew: (): Record<Locale, string> => ({ en: '/teams/new', fr: '/equipes/nouvelle' }),
  team: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}`, fr: `/equipes/${teamSlug}` }),
  teamAbout: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/about`, fr: `/equipes/${teamSlug}/a-propos` }),
  teamCalendar: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/calendar`, fr: `/equipes/${teamSlug}/calendrier` }),
  teamAgenda: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/agenda`, fr: `/equipes/${teamSlug}/agenda` }),
  teamPosts: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/posts`, fr: `/equipes/${teamSlug}/articles` }),
  teamRides: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/rides`, fr: `/equipes/${teamSlug}/sorties` }),
  teamTrips: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/trips`, fr: `/equipes/${teamSlug}/voyages` }),
  teamMembers: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/members`, fr: `/equipes/${teamSlug}/membres` }),
  teamPage: (teamSlug: string, pageSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/pages/${pageSlug}`, fr: `/equipes/${teamSlug}/pages/${pageSlug}` }),
  teamAdmin: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/admin`, fr: `/equipes/${teamSlug}/admin` }),
  teamAdminPlaces: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/admin/places`, fr: `/equipes/${teamSlug}/admin/lieux` }),
  teamAdminTags: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/admin/tags`, fr: `/equipes/${teamSlug}/admin/tags` }),
  teamAdminPages: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/admin/pages`, fr: `/equipes/${teamSlug}/admin/pages` }),
  teamAdminPageNew: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/admin/pages/new`, fr: `/equipes/${teamSlug}/admin/pages/nouvelle` }),
  teamAdminPageEdit: (teamSlug: string, pageSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/admin/pages/${pageSlug}/edit`, fr: `/equipes/${teamSlug}/admin/pages/${pageSlug}/modifier` }),
  teamAdminMembers: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/admin/members`, fr: `/equipes/${teamSlug}/admin/membres` }),
  teamAdminReports: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/admin/reports`, fr: `/equipes/${teamSlug}/admin/signalements` }),
  teamSettings: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/admin/settings`, fr: `/equipes/${teamSlug}/admin/parametres` }),
  rideNew: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/rides/new`, fr: `/equipes/${teamSlug}/sorties/nouvelle` }),
  ride: (teamSlug: string, rideSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/rides/${rideSlug}`, fr: `/equipes/${teamSlug}/sorties/${rideSlug}` }),
  rideGroup: (teamSlug: string, rideSlug: string, groupId: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/rides/${rideSlug}/groups/${groupId}`, fr: `/equipes/${teamSlug}/sorties/${rideSlug}/groupes/${groupId}` }),
  rideGroupMap: (teamSlug: string, rideSlug: string, groupId: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/rides/${rideSlug}/groups/${groupId}/map`, fr: `/equipes/${teamSlug}/sorties/${rideSlug}/groupes/${groupId}/carte` }),
  rideMap: (teamSlug: string, rideSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/rides/${rideSlug}/map`, fr: `/equipes/${teamSlug}/sorties/${rideSlug}/carte` }),
  rideEdit: (teamSlug: string, rideSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/rides/${rideSlug}/edit`, fr: `/equipes/${teamSlug}/sorties/${rideSlug}/modifier` }),
  rideTemplates: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/admin/ride-templates`, fr: `/equipes/${teamSlug}/admin/modeles-sortie` }),
  rideTemplateNew: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/admin/ride-templates/new`, fr: `/equipes/${teamSlug}/admin/modeles-sortie/nouveau` }),
  rideTemplateEdit: (teamSlug: string, templateSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/admin/ride-templates/${templateSlug}/edit`, fr: `/equipes/${teamSlug}/admin/modeles-sortie/${templateSlug}/modifier` }),
  tripNew: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/trips/new`, fr: `/equipes/${teamSlug}/voyages/nouveau` }),
  trip: (teamSlug: string, tripSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/trips/${tripSlug}`, fr: `/equipes/${teamSlug}/voyages/${tripSlug}` }),
  tripEdit: (teamSlug: string, tripSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/trips/${tripSlug}/edit`, fr: `/equipes/${teamSlug}/voyages/${tripSlug}/modifier` }),
  stage: (teamSlug: string, tripSlug: string, stageSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/trips/${tripSlug}/stages/${stageSlug}`, fr: `/equipes/${teamSlug}/voyages/${tripSlug}/etapes/${stageSlug}` }),
  stageMap: (teamSlug: string, tripSlug: string, stageSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/trips/${tripSlug}/stages/${stageSlug}/map`, fr: `/equipes/${teamSlug}/voyages/${tripSlug}/etapes/${stageSlug}/carte` }),
  postNew: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/posts/new`, fr: `/equipes/${teamSlug}/articles/nouveau` }),
  post: (teamSlug: string, postSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/posts/${postSlug}`, fr: `/equipes/${teamSlug}/articles/${postSlug}` }),
  postEdit: (teamSlug: string, postSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/posts/${postSlug}/edit`, fr: `/equipes/${teamSlug}/articles/${postSlug}/modifier` }),
  routes: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/routes`, fr: `/equipes/${teamSlug}/parcours` }),
  routesMap: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/routes/map`, fr: `/equipes/${teamSlug}/parcours/carte` }),
  routeNew: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/routes/new`, fr: `/equipes/${teamSlug}/parcours/nouveau` }),
  route: (teamSlug: string, routeSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/routes/${routeSlug}`, fr: `/equipes/${teamSlug}/parcours/${routeSlug}` }),
  routeMap: (teamSlug: string, routeSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/routes/${routeSlug}/map`, fr: `/equipes/${teamSlug}/parcours/${routeSlug}/carte` }),
  routeEdit: (teamSlug: string, routeSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/routes/${routeSlug}/edit`, fr: `/equipes/${teamSlug}/parcours/${routeSlug}/modifier` }),
  ads: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/classifieds`, fr: `/equipes/${teamSlug}/annonces` }),
  adNew: (teamSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/classifieds/new`, fr: `/equipes/${teamSlug}/annonces/nouvelle` }),
  ad: (teamSlug: string, adSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/classifieds/${adSlug}`, fr: `/equipes/${teamSlug}/annonces/${adSlug}` }),
  adEdit: (teamSlug: string, adSlug: string): Record<Locale, string> => ({ en: `/teams/${teamSlug}/classifieds/${adSlug}/edit`, fr: `/equipes/${teamSlug}/annonces/${adSlug}/modifier` }),
  admin: (): Record<Locale, string> => ({ en: '/platform', fr: '/plateforme' }),
  adminDomains: (): Record<Locale, string> => ({ en: '/platform/domains', fr: '/plateforme/domaines' }),
  adminTeams: (): Record<Locale, string> => ({ en: '/platform/teams', fr: '/plateforme/equipes' }),
  adminUsers: (): Record<Locale, string> => ({ en: '/platform/users', fr: '/plateforme/utilisateurs' }),
  adminReports: (): Record<Locale, string> => ({ en: '/platform/reports', fr: '/plateforme/signalements' }),
  adminMaintenance: (): Record<Locale, string> => ({ en: '/platform/maintenance', fr: '/plateforme/maintenance' }),
} as const

/**
 * App-only deeplinks (web: false): every locale pattern, and the web route a browser lands on
 * instead — the universal link reaches the web whenever the app is not installed.
 */
export const appOnlyFallbacks = [
  { id: 'register', patterns: ['/register', '/inscription'], fallback: 'login' as const },
  { id: 'teamsDiscover', patterns: ['/teams/discover', '/equipes/decouvrir'], fallback: 'teams' as const },
] as const
